/*
  Beans / Single Serve tabs on coffee products.

  The variant picker is re-rendered by the server on every option change, which
  replaces these buttons, so which tab is active is decided in Liquid and never
  tracked here. This only translates a tab press into the radio selections the
  standard variant flow already understands: each tab carries the option value ids
  for its range, and selecting them fires the same change event a pill would.
*/
if (!customElements.get('coffee-format-tabs')) {
  customElements.define(
    'coffee-format-tabs',
    class CoffeeFormatTabs extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const tab = event.target.closest('[data-coffee-format-tab]');
        if (!tab || tab.getAttribute('aria-pressed') === 'true') return;

        const picker = this.closest('variant-selects');
        if (!picker) return;

        // These include the out of range radios, which render hidden rather than
        // omitted precisely so they can be selected from here.
        const targetIds = [tab.dataset.targetFormatId, tab.dataset.targetSizeId].filter(Boolean);
        let lastSelected = null;

        targetIds.forEach((id) => {
          const input = picker.querySelector(`input[data-option-value-id="${id}"]`);
          if (!input) return;
          input.checked = true;
          lastSelected = input;
        });

        // One event is enough: the picker reads every checked input, not just this one.
        if (lastSelected) lastSelected.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
